import MathManager from '@/utils/math-manager.utils'
import { onlyNumbers } from '@/utils/number.utils'
import { BOLETO_PENALTY_ENUM } from '@/enums/boleto-penalty.enum'

const NUMBER_DAYS_IN_MONTH = 30
const PORCENTAGE_MAX = 100

class BoletoPenaltyManager {
  dueAt
  totalAmount
  data
  type

  constructor ({ dueAt, totalAmount, data, type }) {
    this.dueAt = dueAt
    this.totalAmount = totalAmount
    this.data = data
    this.type = type
  }

  convertPercentageInFlat (percentage) {
    const formattedAmount = onlyNumbers(this.totalAmount)

    const flatAmount = formattedAmount * (percentage / PORCENTAGE_MAX)

    if (this.type === BOLETO_PENALTY_ENUM.FINE) {
      return flatAmount
    }

    return flatAmount / NUMBER_DAYS_IN_MONTH
  }

  formatDataAmount () {
    const isPercentage = this.data.amount.includes('%')

    const amount = onlyNumbers(this.data.amount)

    if (!isPercentage) {
      return amount
    }

    return this.convertPercentageInFlat(amount)
  }

  getPenaltyDate () {
    const date = new Date(this.dueAt)
    date.setDate(date.getDate() + this.data.days)
    return date.toISOString()
  }

  formatDataMoney (value) {
    return MathManager.formatCurrencyBRL(value)
  }

  get () {
    const value = this.formatDataMoney(this.formatDataAmount())
    const date = this.getPenaltyDate()

    return { value, date }
  }
}

export default BoletoPenaltyManager
